import React from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import renderIf from "render-if";
import LinearProgress from "@material-ui/core/LinearProgress";

const Wrapper = styled.div`
  max-width: 750px;
  margin-top: 20px;
`;

const Progress = styled(LinearProgress)`
  && {
    margin: 1px 0;
  }
`;

const StyledButton = styled(Button).attrs({
  variant: "outlined",
  color: "primary",
})`
  && {
    margin-right: 10px;
  }
`;

export const SendVerificationSkeleton = ({ ...props }) => {
  return (
    <Wrapper>
      <Typography
        variant="body1"
        color="textSecondary"
        style={{ marginBottom: 10 }}
      >
        We need to verify that you are human.
      </Typography>
      <Typography variant="subtitle1" color="textSecondary">
        Sending verification...
      </Typography>
      <Progress />
    </Wrapper>
  );
};

const SendVerification = ({ error, onClick, ...props }) => {
  const handleClick = (name) => (evt) => {
    evt.target.name = name;
    onClick(evt);
  };

  return (
    <Wrapper {...props}>
      <Typography
        variant="body1"
        color="textSecondary"
        style={{ marginBottom: 10 }}
      >
        We need to verify that you are human. Get a verification code:
      </Typography>
      <StyledButton onClick={handleClick("email")} variant="outlined">
        Send a Email
      </StyledButton>
      <StyledButton onClick={handleClick("phone")} variant="outlined">
        Send a Text
      </StyledButton>
      {renderIf(error)(
        <Typography variant="subtitle2" color="error">
          {error}
        </Typography>
      )}
    </Wrapper>
  );
};

export default SendVerification;
